import {
  DialogProps,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from '@material-ui/core';
import React from 'react';
import { Save as SaveIcon } from '@material-ui/icons';
import { SuccessButton } from 'reactmuicommon';

export interface FormDialogProps extends DialogProps {
  open: boolean;
  children: any;
  handleClose: any;
  formId: string;
  title: any;
  description?: string;
  showLoading?: boolean;
  confirmButtonText?: string;
  hideSave?: boolean;
  onSubmit?: (data: any) => void;
  disabled?: boolean;
}

const FormDialog: React.FC<FormDialogProps> = ({
  open,
  children,
  handleClose,
  formId,
  title,
  showLoading,
  hideSave,
  disabled,
  confirmButtonText,
  ...props
}) => {
  return (
    <Dialog aria-labelledby="form-dialog-title" open={open} {...props}>
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText />
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Kapat
        </Button>
        {!hideSave && (
          <SuccessButton form={formId} type="submit" showLoading={showLoading} disabled={disabled}>
            {confirmButtonText || 'Kaydet'}
          </SuccessButton>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default FormDialog;
